import React from 'react'
import { useState, useEffect, useRef } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import { useLoading } from '../../../context/LoadingContext';
import { FaDownload } from "react-icons/fa6";
import logo from '../../../assets/logo.png';
import jsPDF from "jspdf"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "jspdf-autotable"
import autoTable from "jspdf-autotable";
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';


const Enquiry = ({ adminData, branchID, companyID, financialYear }) => {
    const searchInputRef = useRef(null);
    const navigate = useNavigate();

    const { setLoading } = useLoading();
    const [partyOptions, setPartyOptions] = useState([]);
    const [inventory, setInventory] = useState([]);
    const [purchase, setPurchase] = useState([]);
    const [search, setSearch] = useState("");

    const [showPartyModal, setShowPartyModal] = useState(false);
    const [showItemModal, setShowItemModal] = useState(false);
    const [searchItem, setSearchItem] = useState("");
    const [currentRowIndex, setCurrentRowIndex] = useState(null);
    const [enquiry, setEnquiry] = useState([]);
    const [detail, setDetail] = useState([]);
    const [purchaseOrder, setPurchaseOrder] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState("");
    const [items, setItems] = useState([]);
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [subTotal, setSubTotal] = useState(0);
    const [totalTax, setTotalTax] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [showForm, setShowForm] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [branchDetail, setBranchDetail] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showLetterModal, setShowLetterModal] = useState(false);
    const [company, setCompany] = useState([]);
    const [useDefaultShipping, setUseDefaultShipping] = useState(true);

    useEffect(() => {
        if (showPartyModal) {
            setTimeout(() => {
                searchInputRef.current?.focus();
            }, 100);
        }
    }, [showPartyModal]);


    const getTodayDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    };



    const [offset, setOffset] = useState(0);
    const limit = 20;
    const [hasMore, setHasMore] = useState(true);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [isLocked, setIsLocked] = useState(false);
    const [fy, setFy] = useState([]);
    const [validUpto, setValidUpto] = useState(null);

    const [financialRange, setFinancialRange] = useState({
        from_date: '',
        to_date: ''
    });



    const [formItems, setFormItems] = useState({
        type_acc: '',
        ref_doc: '',
        date: getTodayDateTime(),
        invoice: '',
        invoice_date: '',
        remark: '',
        party: '',
        grand_total: '',
        edit_by: '',
        edit_date: '',
        added_by: '',
        branchId: '',
        delivery: '',
    })

    const [formData, setFormData] = useState([
    ]);



    const [files, setFiles] = useState({
        file: null,
    })

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };

    const selectedParty =
        partyOptions.find((opt) => opt.value === formItems.party)?.label || "";

    // Filter list for modal
    const filtered = partyOptions.filter(
        (p) =>
            p.label.toLowerCase().includes(search.toLowerCase()) ||
            (p.phone && p.phone.toLowerCase().includes(search.toLowerCase())) ||
            (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
    );

    const handleAddClick = () => {
        setShowForm(true);
    }

    const handleEdit = async (form) => {
        const locked = isVoucherLocked(form.date);
        setIsLocked(locked);
        setIsEditMode(true);
        let parsedItems = [];
        try {
            if (form.items) {
                parsedItems = JSON.parse(form.items);
            }
        } catch (err) {
            console.error("Invalid JSON for items:", form.items, err);
            parsedItems = [];
        }


        setFormData(parsedItems);


        setFormItems({
            id: form.id || "",
            date: form.date || "",
            remark: form.remark || "",
            party: form.party || "",
            partyName: form.party_name || "",
            delivery: form.delivery || "",
            inv_no: form.inv_no || "",
            branchId: form.branchId || "",
        });

        setFiles({ file: form.file || null });


        setEditingCompanyId(form.id);
        setShowForm(true);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormItems(prev => ({
            ...prev,
            [name]: value
        }));


    };



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes → MB
            if (fileSizeInMB > 2) {
                setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                return;
            }
            setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
        }
    };


    const handleSelectChange = (e) => {
        const id = e.target.value;
        if (!id) return;


        const selectedItem = items.find((i) => i.id == id);
        if (!selectedItem) return;


        setFormData((prev) => [
            ...prev,
            {
                id: selectedItem.id,
                name: selectedItem.name,
                qty: 0,
                rate: selectedItem.rate || 0,
                amount: "",
                tax: 0,
                hsn: selectedItem.hsn || 0,

            },
        ]);
    };




    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!formItems.party) {
            showToast('Please select a Party !', 'danger');
            return;
        }

        const sendData = new FormData();
        sendData.append("type_acc", "Inquiry");
        sendData.append("date", formItems.date || new Date().toISOString().split("T")[0]);
        sendData.append("ref_doc", formItems.ref_doc);

        sendData.append("invoice", formItems.invoice);
        sendData.append("invoice_date", formItems.invoice_date);
        sendData.append("remark", formItems.remark);
        sendData.append("party", formItems.party);
        sendData.append("grand_total", formItems.grand_total);
        sendData.append("branchId", branchDetail.code);
        sendData.append("delivery", formItems.delivery);

        if (files.file) {
            const maxSizeMB = 2;
            const fileSizeMB = files.file.size / (1024 * 1024);
            if (fileSizeMB > maxSizeMB) {
                showToast(`File size exceeds ${maxSizeMB}MB!`, 'danger');
                return;
            }
            sendData.append("file", files.file);
        }

        // const validItems = formData
        //   .filter(item => item.name && item.name.trim() !== "")
        //   .map(item => ({
        //     id: item.id,
        //     name: item.name,
        //     qty: item.qty !== undefined ? item.qty : "",
        //     rate: item.rate !== undefined ? item.rate : "",

        //     tax: item.tax || "",

        //     amount: item.qty && item.rate ? item.qty * item.rate : ""
        //   }));


        const validItems = formData
            .filter(item => item.name && item.name.trim() !== "")
            .map(item => {

                const qty = Number(item.qty) || 0;
                const rate = Number(item.rate) || 0;
                const gstPercent = Number(item.tax) || 0;
                const discountPercent = Number(item.discount) || 0;


                const baseAmount = qty * rate;


                const discountAmount = Number(
                    ((baseAmount * discountPercent) / 100).toFixed(2)
                );


                const taxableAmount = baseAmount - discountAmount;


                const gstAmount = Number(
                    ((taxableAmount * gstPercent) / 100).toFixed(2)
                );


                const totalAmount = Number(
                    (taxableAmount + gstAmount).toFixed(2)
                );


                return {
                    id: item.id,
                    name: item.name,
                    qty,
                    rate,
                    baseAmount,
                    tax: gstPercent,
                    hsn: item.hsn || "",

                    // discount details
                    discount: discountPercent,
                    discountAmount,
                    taxableAmount,

                    gstAmount,
                    totalAmount
                };
            });

        sendData.append("items", JSON.stringify(validItems));


        try {


            if (isEditMode && editingCompanyId) {
                sendData.append("edit_by", adminData.user.id);

                const res = await axios.put(
                    `https://api.skyguard.group/api/update-purchase-enquiry/${editingCompanyId}`,
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                showToast("Enquiry Updated Successfully!", "success");
                fetchEnquiryDetail(financialRange.from_date,
                    financialRange.to_date,
                    branchDetail.code,
                    0);
                setShowForm(false);
                resetForm();
            } else {
                sendData.append("added_by", adminData.user.id);
                const res = await axios.post(
                    "https://api.skyguard.group/api/add-purchase-enquiry",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }

                )
                fetchEnquiryDetail(financialRange.from_date,
                    financialRange.to_date,
                    branchDetail.code,
                    0);
                setShowForm(false);
                showToast('Enquiry Added successfully!', 'success');
                resetForm();
            }

            setIsEditMode(false)

        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);
            showToast('Fail to added Enquiry  !', 'danger');
        }
    };

    const fetchPartyDetail = async () => {
        setLoading(true)
        try {
            const resParty = await axios.get("https://api.skyguard.group/api/fetch-party-bill");




            const options = resParty.data.map((p) => ({
                value: p.id,
                label: p.name,
                phone: p.phone,
                address: p.address,

            }));

            const data = resParty.data;

            setDetail(data);

            setPartyOptions(options);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };



    const fecthInventory = async () => {
        setLoading(true)
        try {
            const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
            const items = resInventory.data.result || [];
            setItems(items);


        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


    const fetchEnquiryDetail = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {
        setLoading(true);

        if (!branchCode) {
            console.log("Branch code missing");
            return;
        }
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-enquiry-detail",

                {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
            );


            // const sortedData = resPurchase.data
            //   .sort((a, b) => new Date(b.date) - new Date(a.date));
            // setEnquiry(sortedData);

            const result = res.data;

            if (newOffset === 0) {
                setEnquiry(result);
                setHasMore(true);
            }

            else {
                setEnquiry(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }


        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };


    const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const fetchYearDetail = async () => {
        setLoading(true);
        try {
            const branchCode = await fetchBranchDetail();
            const res = await axios.get(
                `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
            );
            const yearData = res.data;
            setFy(yearData);
            // setIsLocked(yearData.is_locked === 1);

            setValidUpto(yearData.valid_up_to);
            let shouldLock = false;

            // First check is_locked
            if (Number(yearData.is_locked) === 1) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const validUptoDate = new Date(yearData.valid_up_to);
                validUptoDate.setHours(0, 0, 0, 0);

                // Lock only if valid_up_to date has passed
                shouldLock = validUptoDate <= today;
            }

            setIsLocked(shouldLock);


            setFinancialRange({
                from_date: yearData.from_date,
                to_date: yearData.to_date
            });

            await fetchEnquiryDetail(
                yearData.from_date,
                yearData.to_date,
                branchCode,

            );
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const isVoucherLocked = (paymentDate) => {
        if (!validUpto || !paymentDate) return false;

        const voucherDate = new Date(paymentDate);
        voucherDate.setHours(0, 0, 0, 0);

        const fyValidUpto = new Date(validUpto);
        fyValidUpto.setHours(0, 0, 0, 0);

        return voucherDate <= fyValidUpto;
    };

    const fetchCompany = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
            setCompany(res.data);

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchBranchDetail();
        fetchYearDetail();

        fetchPartyDetail();
        fecthInventory();
        fetchCompany();
    }, []);


    const resetForm = () => {
        setFormItems({
            type_acc: '',
            ref_doc: '',
            date: getTodayDateTime(),
            invoice: '',
            invoice_date: '',
            remark: '',
            party: '',
            grand_total: '',
            edit_by: '',
            edit_date: '',
            added_by: '',
            delivery: '',
        });

        setFormData([]);
        setFiles({});
        setShowForm(false);
    };


    const formatDateTime = (datetime) => {
        if (!datetime) return "";
        const [date, time] = datetime.split(" ");
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year} ${time}`;
    };


    const filteredData = Array.isArray(enquiry)
        ? enquiry.filter(itm =>
            Object.values(itm).some(val =>
                String(val).toLowerCase().includes(searchTerm.toLowerCase())
            )
        )
        : [];



    const handleViewQuotation = (quotation) => {
        if (!quotation) {
            console.warn("No Enquiry passed to handleViewQuotation()");
            return;
        }

        setSelectedQuotation(quotation);
        setShowDownloadModal(true);
    };


    const exportInvoiceToPDF = (selectedQuotation) => {
        const doc = new jsPDF("p", "mm", "a4");

        let currentY = 15;

        /* ================= HEADER ================= */
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("STAR SIGNATURE SERVICES", 14, currentY);

        currentY += 6;

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");

        const addressText =
            "A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA BRANCH: DADAR, THANE, PUNE, AURANGABAD, GOA PANJIM";

        const addressLines = doc.splitTextToSize(addressText, 180);
        doc.text(addressLines, 14, currentY);

        currentY += addressLines.length * 4;

        doc.text(
            "Phone: 9209206677 / 9209203355 / 9324004632",
            14,
            currentY
        );
        currentY += 4;

        doc.text(
            "Email: starsignatureservices@gmail.com",
            14,
            currentY
        );
        currentY += 4;

        doc.text("GSTIN: 27ADYPY53133M2ZH", 14, currentY);

        currentY += 8;
        doc.line(14, currentY, 196, currentY);
        currentY += 6;

        /* ================= CUSTOMER DETAIL BOX ================= */
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text("Customer Detail", 16, currentY);

        currentY += 2;
        doc.line(16, currentY, 80, currentY);
        currentY += 5;

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        doc.text(`Name: ${selectedQuotation.party_name}`, 16, currentY);
        currentY += 5;

        doc.text(`Contact: ${selectedQuotation.party_phone}`, 16, currentY);
        currentY += 5;

        doc.text(`Address: ${selectedQuotation.party_address}`, 16, currentY);
        currentY += 5;

        doc.text(`Date: ${selectedQuotation.date}`, 16, currentY);
        currentY += 5;

        doc.text(
            `Bill By: ${selectedQuotation.added_first_name || ""} ${selectedQuotation.added_middle_name || ""} ${selectedQuotation.added_last_name || ""}`,
            16,
            currentY
        );

        currentY += 8;

        /* ================= ITEMS TABLE ================= */
        const items = selectedQuotation.items
            ? JSON.parse(selectedQuotation.items)
            : [];

        autoTable(doc, {
            startY: currentY,
            theme: "grid",
            styles: {
                fontSize: 10,
                cellPadding: 3
            },
            headStyles: {
                fillColor: [240, 240, 240],
                textColor: 0,
                fontStyle: "bold"
            },
            head: [["Item Name", "Qty"]],
            body: items.length
                ? items.map((it) => [it.name, it.qty])
                : [["No Items Found", ""]],
            columnStyles: {
                0: { halign: "left" },
                1: { halign: "center", cellWidth: 30 }
            }
        });

        currentY = doc.lastAutoTable.finalY + 6;

        /* ================= REMARK ================= */
        if (selectedQuotation.remark) {
            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text("Remark:", 14, currentY);

            doc.setFont("helvetica", "normal");
            const remarkLines = doc.splitTextToSize(
                selectedQuotation.remark,
                180
            );
            doc.text(remarkLines, 14, currentY + 4);
        }

        /* ================= SAVE ================= */
        doc.save(
            `Customer_Detail_${selectedQuotation.party_name || "Invoice"}.pdf`
        );
    };




    //   const handlePrint = () => {
    //   const printContents = document.getElementById("invoice-print-area");

    //   const printWindow = window.open("", "_blank");

    //   printWindow.document.write(`
    //     <html>
    //       <head>
    //         <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
    //         <style>
    //           body { margin: 10px; }
    //         </style>
    //       </head>
    //       <body></body>
    //     </html>
    //   `);

    //   printWindow.document.close();

    //   // ✅ Clone exact node (keeps structure better)
    //   const clonedContent = printContents.cloneNode(true);
    //   printWindow.document.body.appendChild(clonedContent);

    //   printWindow.focus();
    //   printWindow.print();
    //   printWindow.close();
    // };


    const handlePrint = () => {
        const printContents = document.getElementById("invoice-print-area");

        if (!printContents) return;

        const printWindow = window.open("", "_blank", "width=900,height=700");

        printWindow.document.write(`
        <html>
            <head>
                <title>Invoice</title>

                <link
                    rel="stylesheet"
                    href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
                />

                <style>
                    @page {
                        size: A4;
                        margin: 10mm;
                    }

                    body {
                        margin: 0;
                        padding: 10px;
                        background: #fff;
                        font-family: Arial, sans-serif;
                    }

                    #invoice-print-area {
                        width: 100%;
                    }

                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }

                    img {
                        max-width: 100%;
                    }

                    .no-print {
                        display: none !important;
                    }
                </style>
            </head>

            <body>
                ${printContents.outerHTML}
            </body>
        </html>
    `);

        printWindow.document.close();

        // Wait for images/fonts to load
        printWindow.onload = () => {
            setTimeout(() => {
                printWindow.focus();
                printWindow.print();

                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 500);
        };
    };
    const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        fetchEnquiryDetail(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };


    const thStyle = {
        border: "1px solid #000",
        padding: "8px",
        textAlign: "center",
        fontWeight: "bold",
    };

    const tdCenter = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "center",
    };

    const tdLeft = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "left",
    };

    const tdRight = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "right",
    };
    const summaryTitle = {
        border: "1px solid #000",
        padding: "8px",
        fontWeight: "bold",
    };

    const summaryValue = {
        border: "1px solid #000",
        padding: "8px",
        textAlign: "right",
    };


    const bankTitle = {
        border: "1px solid #000",
        padding: "8px",
        fontWeight: "bold",
        width: "35%",
    };

    const bankValue = {
        border: "1px solid #000",
        padding: "8px",
    };

    return (
        <div className='main-section'>
            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>Purchase Enquiry</h3>
                {/* Search + Add */}
                <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
                    <div class="col-12 col-md-4 ">
                        <input
                            type="text"
                            class="form-control"
                            id="searchInput"
                            placeholder="Search "
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>


                    <div className="col-12 col-md-2 d-flex justify-content-end">
                        <button
                            className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                            onClick={() => {
                                setShowForm(prev => !prev);

                                if (showForm) {
                                    setIsEditMode(false);
                                    setEditingCompanyId(null);
                                    resetForm();
                                }
                            }}
                        >
                            {showForm ? (
                                <>
                                    Close <FaTimes size={18} />
                                </>
                            ) : (
                                <>
                                    Add <AiOutlinePlusCircle size={18} />
                                </>
                            )}
                        </button>
                    </div>
                </div>
                {/* form */}

                {showForm && (
                    <fieldset >
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <div className='row'>
                                <div className='col-12'>

                                    {isEditMode && (
                                        <div className="mb-3">
                                            <label>Document No:</label> <br />
                                            <span className="badge bg-primary px-3 py-2">
                                                {`PE/${formItems.inv_no}/${formItems.branchId}`}
                                            </span>
                                        </div>
                                    )}


                                    <div className='row g-3'>

                                        <div className="col-12 col-md-4">
                                            <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Choose Party..."
                                                // value={selectedParty}
                                                value={formItems.partyName || ""}
                                                readOnly
                                                onClick={() => setShowPartyModal(true)}
                                                required
                                                disabled={isEditMode && isLocked}

                                            />

                                            {/* Inline Modal */}
                                            <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Search Party</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search by name, phone, or address"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                        ref={searchInputRef}
                                                    />
                                                    <div className="table-responsive mt-3">
                                                        <Table striped bordered hover className="mt-3">
                                                            <thead>
                                                                <tr>
                                                                    <th>Action </th>
                                                                    <th>Name</th>
                                                                    <th>Phone</th>
                                                                    <th>Address</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {filtered.map((p) => (
                                                                    <tr key={p.value}>
                                                                        <td className="text-center" style={{ width: "80px" }} >
                                                                            <Button
                                                                                variant="primary"
                                                                                size="sm"
                                                                                onClick={() => {
                                                                                    setFormItems((prev) => ({
                                                                                        ...prev,
                                                                                        party: p.value,
                                                                                        partyName: p.label,
                                                                                        delivery: p.address,
                                                                                    }));
                                                                                    setUseDefaultShipping(true);
                                                                                    setShowPartyModal(false);
                                                                                }}
                                                                            >
                                                                                Select
                                                                            </Button>
                                                                        </td>
                                                                        <td>{p.label}</td>
                                                                        <td>{p.phone}</td>
                                                                        {/* <td>{p.address}</td> */}
                                                                        <td
                                                                            style={{
                                                                                maxWidth: "300px",
                                                                                whiteSpace: "normal",
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis",
                                                                            }}
                                                                        >
                                                                            {(p.address || "").length > 50
                                                                                ? `${(p.address || "").slice(0, 50)}...`
                                                                                : (p.address || "NA")}

                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>

                                                </Modal.Body>
                                            </Modal>



                                        </div>

                                        <div className="col-12 col-md-4">
                                            <label htmlFor='date' className="form-label fw-medium">Enter Date</label>

                                            <input type="datetime-local" className="form-control" id="date" name="date"
                                                value={formItems.date || new Date().toISOString().split("T")[0]}
                                                onChange={handleChange}
                                                disabled={isEditMode && isLocked}
                                            />
                                        </div>




                                        <div className="col-12 col-md-4">
                                            <div className="d-flex align-items-center gap-2 text-nowrap">
                                                <label htmlFor="delivery" className="fw-medium mb-0">
                                                    Shipping Address
                                                </label>

                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0"
                                                    id="editShipping"
                                                    checked={!useDefaultShipping}
                                                    onChange={() => setUseDefaultShipping(!useDefaultShipping)}
                                                    disabled={isEditMode && isLocked}
                                                />

                                                <span className="text-muted">Change Address</span>
                                            </div>

                                            <input
                                                type="text"
                                                className="form-control mt-1"
                                                id="delivery"
                                                name="delivery"
                                                value={formItems.delivery || ""}
                                                onChange={handleChange}
                                                disabled={useDefaultShipping}
                                                disabled={isEditMode && isLocked}
                                            />
                                        </div>

                                    </div>
                                </div>

                            </div>




                            <div className="col-12 col-md-6">
                                <label className="form-label fw-medium">Items:</label>

                                <div className="d-flex gap-2">
                                    <div className="flex-grow-1">
                                        <Select
                                            options={items.map((t) => ({
                                                value: t.id,
                                                label: `${t.name} (${t.stock})  | ${t.category}`,
                                            }))}


                                            value={
                                                selectedItemId
                                                    ? (() => {
                                                        const item = items.find((i) => i.id === selectedItemId);

                                                        return item
                                                            ? {
                                                                value: item.id,
                                                                label: `${item.name} (${item.stock}) | ${item.category} | ${item.group_item}`,
                                                            }
                                                            : null;
                                                    })()
                                                    : null
                                            }

                                            onChange={(e) =>
                                                handleSelectChange({
                                                    target: { name: "emp_id", value: e?.value || "" },
                                                })
                                            }

                                            className="w-100"
                                            menuPlacement="auto"
                                            isDisabled={isEditMode && isLocked}
                                        />
                                    </div>

                                    {!isEditMode && (
                                        <button className="btn btn-primary"
                                            onClick={() => {
                                                navigate("/admin/inventory", {
                                                    state: {
                                                        showAddForm: true,

                                                    }
                                                });
                                            }}
                                        >
                                            Add New Item
                                        </button>
                                    )}

                                </div>

                            </div>



                            <div className="table-responsive my-4">

                                <Table className="table table-bordered text-center align-middle w-50 md-sm-100 ">
                                    <thead className="table-primary">
                                        <tr>
                                            <th>Item Name</th>
                                            <th  >Qty</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>


                                        {formData.map((item, idx) =>
                                            item.name ? (
                                                <tr key={idx}>
                                                    <td isDisabled={isEditMode && isLocked}>{item.name} </td>
                                                    <td className="w-25">

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={item.qty || ''}
                                                            onChange={(e) => {
                                                                const updated = [...formData];
                                                                updated[idx] = { ...updated[idx], qty: e.target.value };
                                                                setFormData(updated);

                                                            }}
                                                            disabled={isEditMode && isLocked}
                                                        />




                                                    </td>
                                                    <td>
                                                        <button
                                                            className="btn btn-danger"
                                                            onClick={() => setFormData(formData.filter((_, i) => i !== idx))}
                                                            disabled={isEditMode && isLocked}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ) : null
                                        )}


                                    </tbody>
                                </Table>


                                <Modal
                                    show={showItemModal}
                                    onHide={() => setShowItemModal(false)}
                                    size="lg"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title>Select Item</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search item..."
                                            value={searchItem}
                                            onChange={(e) => setSearchItem(e.target.value)}
                                            className="mb-3"


                                        />
                                        <table className="table table-hover text-center">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>

                                                    <th>Select</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {inventory
                                                    .filter((i) =>
                                                        i.name.toLowerCase().includes(searchItem.toLowerCase())
                                                    )
                                                    .map((i) => (
                                                        <tr key={i.id}>
                                                            <td>{i.name}</td>

                                                            <td>
                                                                <Button
                                                                    variant="primary"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        const updated = [...formData];

                                                                        updated[currentRowIndex] = {
                                                                            ...updated[currentRowIndex],
                                                                            name: i.name,
                                                                            rate: '',
                                                                            amount: ''
                                                                        };
                                                                        setFormData(updated);
                                                                        setShowItemModal(false);
                                                                    }}
                                                                >
                                                                    Select
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </Modal.Body>
                                </Modal>


                            </div>
                            {/* attachment+Remark */}

                            <div className='row' >
                                <div className='col-md-6'>
                                    <div className="form-group">
                                        <label htmlFor="attachment" className='form-label fw-medium'>Attachment</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="attachment"
                                            name='file'
                                            accept="image/*,application/pdf"
                                            onChange={handleFileChange}
                                            disabled={isEditMode && isLocked}

                                        />
                                        {isEditMode && files.file && typeof files.file === "string" && (
                                            <div className="mt-2">
                                                <span>Previous file: </span>
                                                <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="description" className='form-label fw-medium'>Remark</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows="5"
                                            placeholder="Enter description here..."
                                            name='remark'
                                            value={formItems.remark}
                                            onChange={handleChange}
                                            disabled={isEditMode && isLocked}
                                        ></textarea>
                                    </div>
                                </div> </div>



                            {/* Save/Cancel */}
                            <div className='gap-2 d-flex justify-content-center mt-4'>

                                <button type="button" className='btn btn-success' onClick={handleSubmit} disabled={isEditMode && isLocked}>{isEditMode ? "Update" : "Save"} </button>
                                <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </fieldset>

                )}
                {/* main-table */}
                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                <th scope='col'>SN</th>
                                <th scope='col' >Action</th>
                                <th scope='col' > Enquiry No. </th>
                                <th scope='col'>Party Name</th>


                                <th scope='col'>Added By</th>
                                <th scope='col'>Added Date</th>

                                <th scope='col'>Edit By</th>

                                <th scope='col'>Edit Date</th>


                            </tr>
                        </thead>



                        <tbody>
                            {filteredData.map((p, i) => (
                                <tr key={p.id}>
                                    <td>{filteredData.length - i}</td>
                                    <td>

                                        <button
                                            className="btn btn-success"

                                            onClick={() => handleEdit(p)}
                                        >
                                            <CiEdit size={20} />
                                        </button>

                                        <button
                                            className="btn btn-warning mx-1"
                                            onClick={() => handleViewQuotation(p)}


                                        >
                                            <FaDownload size={20} />
                                        </button>



                                    </td>
                                    <td>{`PE/${p.inv_no}/${branchDetail.code}/${fy.financial_year.split('-')[0]}`}</td>

                                    <td>{p.party_name}</td>
                                    <td>{p.added_first_name} {p.added_middle_name || ""} {p.added_last_name} </td>
                                    <td>{formatDateTime(p.date)}</td>
                                    <td>{p.edit_first_name} {p.edit_middle_name || ""} {p.edit_last_name} </td>
                                    <td>{formatDateTime(p.edit_date)} </td>
                                    {/* <td>{p.edit_date} </td> */}

                                </tr>
                            ))}
                        </tbody>
                    </table>


                    {showDownloadModal && selectedQuotation && (() => {
                        const parsedItems = selectedQuotation.items
                            ? JSON.parse(selectedQuotation.items)
                            : [];

                        const parsedAdditionalDetails = selectedQuotation.additional_charges
                            ? JSON.parse(selectedQuotation.additional_charges)
                            : [];


                        const headerImageUrl = `https://api.skyguard.group/uploads/${branchDetail.header_img}`;

                        return (
                            <>
                                <div
                                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                    style={{
                                        backgroundColor: "rgba(0,0,0,0.5)",
                                        zIndex: 9999,
                                    }}
                                >

                                    <div
                                        style={{
                                            background: "transparent",
                                            width: "95%",
                                            maxWidth: "1000px",
                                            borderRadius: "0",
                                            padding: "0",
                                            maxHeight: "95vh",
                                            overflowY: "auto",
                                            position: "relative",
                                            boxShadow: "none",
                                        }}
                                    >

                                        <button
                                            onClick={() => setShowDownloadModal(false)}
                                            style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "10px",
                                                border: "none",
                                                background: "transparent",
                                                fontSize: "20px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            ✖
                                        </button>


                                        <div
                                            id="invoice-print-area"
                                            style={{
                                                position: "relative",
                                                background: "#fff",
                                                border: "2px solid #000",
                                                fontFamily: "Arial",
                                                fontSize: "13px",
                                            }}
                                        >

                                            {/* Watermark */}
                                            <img
                                                src={headerImageUrl}
                                                alt=""
                                                style={{
                                                    position: "absolute",
                                                    top: "45%",
                                                    left: "50%",
                                                    transform: "translate(-50%,-50%)",
                                                    width: "350px",
                                                    opacity: 0.09,
                                                    zIndex: 0,
                                                }}
                                            />

                                            <div style={{ position: "relative", zIndex: 2 }}>

                                                {/* ================= HEADER ================= */}

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        borderBottom: "2px solid #000",
                                                        minHeight: "70px",
                                                    }}
                                                >

                                                    {/* Title */}

                                                    <div
                                                        style={{
                                                            flex: 1,
                                                            // background: "var(--invoice-header)",
                                                            // color: "#fff",
                                                            color: "#fff",
                                                            background: "#2badea",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: "28px",
                                                            fontWeight: "bold",
                                                            letterSpacing: 1,
                                                        }}
                                                    >
                                                        PURCHASE QUOTATION
                                                    </div>

                                                    {/* Logo */}

                                                    <div
                                                        style={{
                                                            width: "120px",
                                                            borderLeft: "2px solid #000",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        {branchDetail?.header_img ? (
                                                            <img
                                                                src={headerImageUrl}
                                                                alt=""
                                                                style={{
                                                                    width: "100px",
                                                                    height: "60px",
                                                                    objectFit: "contain",
                                                                }}
                                                            />
                                                        ) : (
                                                            <h3>LOGO</h3>
                                                        )}
                                                    </div>

                                                </div>

                                                {/* ================= COMPANY + INVOICE ================= */}

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        borderBottom: "2px solid #000",
                                                    }}
                                                >

                                                    {/* LEFT */}

                                                    <div
                                                        style={{
                                                            width: "52%",
                                                            borderRight: "2px solid #000",
                                                            padding: 6,
                                                        }}
                                                    >

                                                        <h6
                                                            style={{
                                                                marginBottom: 10,
                                                                fontWeight: "bold",
                                                                // color: "#9d1f4f",
                                                                color: 'var(--invoice-header)'
                                                            }}
                                                        >
                                                            COMPANY DETAILS
                                                        </h6>

                                                        <div><b>{company.name}</b></div>

                                                        <div>{company.address}</div>

                                                        <div>
                                                            {company.city}, {company.state}
                                                        </div>

                                                        <div>
                                                            PIN : {company.pincode}
                                                        </div>

                                                        <div>
                                                            GSTIN : {company.gst}
                                                        </div>

                                                        <div>
                                                            PHONE : {company.phone}
                                                        </div>

                                                        <div>
                                                            EMAIL : {company.email}
                                                        </div>

                                                        <div>
                                                            PAN : {company.pan}
                                                        </div>

                                                    </div>

                                                    {/* RIGHT */}

                                                    <div
                                                        style={{
                                                            width: "48%",
                                                        }}
                                                    >

                                                        <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "collapse",
                                                            }}
                                                        >

                                                            <tbody>

                                                                <tr>

                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #000",
                                                                            padding: 6,
                                                                            width: "42%",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        Quotation No
                                                                    </td>

                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #000",
                                                                            padding: 6,
                                                                        }}
                                                                    >
                                                                        {selectedQuotation.id}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        Date
                                                                    </td>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        {selectedQuotation.date}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        Shipping Address
                                                                    </td>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        {selectedQuotation.delivery}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        Destination
                                                                    </td>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        {selectedQuotation.party_city}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        State
                                                                    </td>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        {selectedQuotation.party_state}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        GSTIN
                                                                    </td>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        {selectedQuotation.party_gst}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        Phone
                                                                    </td>

                                                                    <td style={{ border: "1px solid #000", padding: 6 }}>
                                                                        {selectedQuotation.party_phone}
                                                                    </td>

                                                                </tr>

                                                            </tbody>

                                                        </table>

                                                    </div>

                                                </div>

                                                {/* BUYER DETAILS START HERE */}


                                                {/* ================= BUYER + TERMS ================= */}

                                                <div
                                                    style={{
                                                        width: "100%",
                                                        padding: "8px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontWeight: "bold",
                                                            // color: "#9d1f4f",
                                                            color: 'var(--invoice-header)',
                                                            fontSize: "12px",
                                                            marginBottom: "15px",
                                                            borderBottom: "1px solid #000",
                                                            paddingBottom: "5px",
                                                        }}
                                                    >
                                                        BUYER DETAILS
                                                    </div>

                                                    {/* Row 1 */}
                                                    <div style={{ display: "flex", marginBottom: "6px" }}>
                                                        <div style={{ flex: 1 }}>
                                                            <b>Party Name</b><br />
                                                            {selectedQuotation.party_name}
                                                        </div>

                                                        <div style={{ flex: 1 }}>
                                                            <b>Phone</b><br />
                                                            {selectedQuotation.party_phone}
                                                        </div>

                                                        <div style={{ flex: 1 }}>
                                                            <b>Email</b><br />
                                                            {selectedQuotation.party_email}
                                                        </div>
                                                    </div>

                                                    {/* Row 2 */}
                                                    <div style={{ display: "flex", marginBottom: "12px" }}>
                                                        <div style={{ flex: 1 }}>
                                                            <b>State</b><br />
                                                            {selectedQuotation.party_state}
                                                        </div>

                                                        <div style={{ flex: 1 }}>
                                                            <b>City</b><br />
                                                            {selectedQuotation.party_city}
                                                        </div>

                                                        <div style={{ flex: 1 }}>
                                                            <b>Pincode</b><br />
                                                            {selectedQuotation.party_pincode}
                                                        </div>
                                                    </div>

                                                    {/* Row 3 */}
                                                    <div style={{ display: "flex", marginBottom: "12px" }}>
                                                        <div style={{ flex: 1 }}>
                                                            <b>Region</b><br />
                                                            {selectedQuotation.party_region}
                                                        </div>

                                                        <div style={{ flex: 1 }}>
                                                            <b>CIN No</b><br />
                                                            {selectedQuotation.party_cin}
                                                        </div>

                                                        <div style={{ flex: 1 }}>
                                                            <b>MSME</b><br />
                                                            {selectedQuotation.party_msme}
                                                        </div>
                                                    </div>

                                                    {/* Row 4 */}
                                                    <div style={{ display: "flex" }}>
                                                        <div style={{ flex: 3 }}>
                                                            <b>Address</b><br />
                                                            {selectedQuotation.party_address}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ================= ITEMS TABLE START ================= */}


                                                <table
                                                    style={{
                                                        width: "100%",
                                                        borderCollapse: "collapse",
                                                        fontSize: "10px",
                                                    }}
                                                >

                                                    <thead>

                                                        <tr
                                                            style={{
                                                                // background: "#d88aa8",
                                                                background: 'var(--invoice-header)',
                                                                color: "#000",
                                                            }}
                                                        >

                                                            <th style={thStyle}>SL</th>

                                                            <th style={thStyle}>ITEM / DESCRIPTION</th>

                                                            <th style={thStyle}>HSN</th>

                                                            <th style={thStyle}>QTY</th>
                                                            <th style={thStyle}>RATE</th>
                                                            <th style={thStyle}>GST</th>

                                                            <th style={thStyle}>AMOUNT</th>

                                                        </tr>

                                                    </thead>

                                                    <tbody>

                                                        {parsedItems.map((item, index) => (

                                                            <tr key={index}>

                                                                <td style={tdCenter}>
                                                                    {index + 1}
                                                                </td>

                                                                <td style={tdLeft}>
                                                                    {item.name}
                                                                </td>

                                                                <td style={tdCenter}>
                                                                    {item.hsn || "-"}
                                                                </td>

                                                                <td style={tdCenter}>
                                                                    {item.qty}
                                                                </td>


                                                                <td style={tdRight}>
                                                                    ₹ {Number(item.rate).toFixed(2)}
                                                                </td>

                                                                <td style={tdRight}>
                                                                    {Number(item.tax).toFixed(2)}
                                                                </td>

                                                                <td style={tdRight}>
                                                                    ₹ {Number(item.totalAmount).toFixed(2)}
                                                                </td>

                                                            </tr>

                                                        ))}



                                                        {Array.from({
                                                            length: Math.max(0, 3 - parsedItems.length),
                                                        })

                                                        }

                                                        {/* Additional Charges */}

                                                        {parsedAdditionalDetails.length > 0 && (

                                                            parsedAdditionalDetails.map((charge, index) => (

                                                                <tr key={index}>

                                                                    <td
                                                                        colSpan="6"
                                                                        style={{
                                                                            border: "1px solid #000",
                                                                            textAlign: "right",
                                                                            padding: "6px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {charge.type}
                                                                    </td>

                                                                    <td style={tdRight}>
                                                                        ₹ {Number(charge.value2 || 0).toFixed(2)}
                                                                    </td>

                                                                </tr>

                                                            ))

                                                        )}

                                                    </tbody>

                                                </table>


                                                {/* ===================== SUMMARY ===================== */}

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        border: "2px solid #000",
                                                        borderTop: "none",
                                                        minHeight: "170px",
                                                    }}
                                                >

                                                    {/* LEFT */}

                                                    <div
                                                        style={{
                                                            width: "60%",
                                                            borderRight: "2px solid #000",
                                                            padding: "12px",
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                fontWeight: "bold",
                                                                // color: "#9d1f4f",
                                                                color: 'var(--invoice-header)',
                                                                fontSize: "16px",
                                                                marginBottom: "10px",
                                                            }}
                                                        >
                                                            AMOUNT IN WORDS
                                                        </div>

                                                        <div
                                                            style={{
                                                                minHeight: "45px",
                                                                border: "1px solid #000",
                                                                padding: "8px",
                                                                marginBottom: "15px",
                                                            }}
                                                        >
                                                            Rupees Only
                                                        </div>

                                                        <div
                                                            style={{
                                                                fontWeight: "bold",
                                                                // color: "#9d1f4f",
                                                                color: 'var(--invoice-header)',
                                                                fontSize: "12px",
                                                                marginBottom: "10px",
                                                            }}
                                                        >
                                                            NOTES
                                                        </div>

                                                        <div
                                                            style={{
                                                                minHeight: "55px",
                                                                border: "1px solid #000",
                                                                padding: "8px",
                                                            }}
                                                        >
                                                            {selectedQuotation.remark
                                                                ? selectedQuotation.remark
                                                                    .split(/(?=\d+\.)/)
                                                                    .map((item, index) => (
                                                                        <div key={index}>
                                                                            {item.trim()}
                                                                        </div>
                                                                    ))
                                                                : (
                                                                    <>
                                                                        <div>1. Goods once sold will not be taken back.</div>

                                                                        <div>2. Subject to Mumbai Jurisdiction.</div>

                                                                        <div>3. Delivery as per commitment.</div>

                                                                        <div>4. Payment as agreed.</div>

                                                                        <div>5. Thank you for your business.</div>
                                                                    </>
                                                                )}
                                                        </div>

                                                    </div>

                                                    {/* RIGHT */}

                                                    <div
                                                        style={{
                                                            width: "40%",
                                                        }}
                                                    >

                                                        <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "collapse",
                                                                height: "100%",
                                                            }}
                                                        >

                                                            <tbody>

                                                                <tr>

                                                                    <td style={summaryTitle}>
                                                                        Sub Total
                                                                    </td>

                                                                    <td style={summaryValue}>
                                                                        ₹ {Number(selectedQuotation.sub_total || selectedQuotation.grand_total).toFixed(2)}
                                                                    </td>

                                                                </tr>



                                                                {parsedAdditionalDetails.map((charge, index) => {

                                                                    const gstPercent = Number(charge.gst || 0);
                                                                    const chargeAmount = Number(charge.charge_amount || charge.value2 || 0);
                                                                    const gstAmount = Number(charge.gst_amount || 0);
                                                                    const finalAmount = chargeAmount + gstAmount;

                                                                    // Check if this is a transport charge
                                                                    const isTransport =
                                                                        charge.type?.toLowerCase().includes("transport") ||
                                                                        charge.type?.toLowerCase().includes("transportation")


                                                                    return (
                                                                        <tr key={index}>
                                                                            <td style={summaryTitle}>
                                                                                {charge.type}

                                                                                {isTransport && gstPercent > 0 && (
                                                                                    <>
                                                                                        <span style={{ fontWeight: "normal" }}>
                                                                                            {" "} ( GST {gstPercent}%)
                                                                                        </span>
                                                                                        <span className='text-primary'>
                                                                                            SAC 9968
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                            </td>

                                                                            <td style={summaryValue}>
                                                                                ₹ {finalAmount.toFixed(2)}
                                                                            </td>
                                                                        </tr>
                                                                    );

                                                                })}
                                                                <tr>

                                                                    <td style={summaryTitle}>
                                                                        Discount
                                                                    </td>

                                                                    <td style={summaryValue}>
                                                                        ₹ {Number(selectedQuotation.bill_discount_value || 0).toFixed(2)}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={summaryTitle}>
                                                                        CGST
                                                                    </td>

                                                                    <td style={summaryValue}>
                                                                        ₹ {Number(selectedQuotation.cgst || 0).toFixed(2)}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={summaryTitle}>
                                                                        SGST
                                                                    </td>

                                                                    <td style={summaryValue}>
                                                                        ₹ {Number(selectedQuotation.sgst || 0).toFixed(2)}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={summaryTitle}>
                                                                        IGST
                                                                    </td>

                                                                    <td style={summaryValue}>
                                                                        ₹ {Number(selectedQuotation.igst || 0).toFixed(2)}
                                                                    </td>

                                                                </tr>

                                                                <tr>

                                                                    <td style={summaryTitle}>
                                                                        Round Off
                                                                    </td>

                                                                    <td style={summaryValue}>
                                                                        ₹ {Number(selectedQuotation.round_off || 0).toFixed(2)}
                                                                    </td>

                                                                </tr>

                                                                <tr
                                                                    style={{
                                                                        // background: "#d88aa8",
                                                                        background: 'var(--invoice-header)',
                                                                        fontWeight: "bold",
                                                                        fontSize: "12px",
                                                                    }}
                                                                >

                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #000",
                                                                            padding: "10px",
                                                                        }}
                                                                    >
                                                                        GRAND TOTAL
                                                                    </td>

                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #000",
                                                                            padding: "10px",
                                                                            textAlign: "right",
                                                                        }}
                                                                    >
                                                                        ₹ {Number(selectedQuotation.grand_total).toFixed(2)}
                                                                    </td>

                                                                </tr>

                                                            </tbody>

                                                        </table>

                                                    </div>

                                                </div>


                                                {/* ===================== BANK DETAILS ===================== */}

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        border: "2px solid #000",
                                                        borderTop: "none",
                                                    }}
                                                >

                                                    {/* Company Bank */}

                                                    <div
                                                        style={{
                                                            width: "50%",
                                                            borderRight: "2px solid #000",
                                                            padding: "12px",
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                // background: "#d88aa8",
                                                                background: 'var(--invoice-header)',
                                                                padding: "8px",
                                                                fontWeight: "bold",
                                                                marginBottom: "10px",
                                                            }}
                                                        >
                                                            COMPANY BANK DETAILS
                                                        </div>

                                                        <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "collapse",
                                                            }}
                                                        >

                                                            <tbody>

                                                                <tr>
                                                                    <td style={bankTitle}>Bank Name</td>
                                                                    <td style={bankValue}>{company.bank_name}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={bankTitle}>Account No.</td>
                                                                    <td style={bankValue}>{company.acc_no}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={bankTitle}>IFSC</td>
                                                                    <td style={bankValue}>{company.ifsc}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={bankTitle}>Branch</td>
                                                                    <td style={bankValue}>{company.branch}</td>
                                                                </tr>

                                                            </tbody>

                                                        </table>

                                                    </div>

                                                    {/* Customer Bank */}

                                                    <div
                                                        style={{
                                                            width: "50%",
                                                            padding: "12px",
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                // background: "#d88aa8",
                                                                background: 'var(--invoice-header)',
                                                                padding: "8px",
                                                                fontWeight: "bold",
                                                                marginBottom: "10px",
                                                            }}
                                                        >
                                                            CUSTOMER BANK DETAILS
                                                        </div>

                                                        <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "collapse",
                                                            }}
                                                        >

                                                            <tbody>

                                                                <tr>
                                                                    <td style={bankTitle}>Bank Name</td>
                                                                    <td style={bankValue}>-</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={bankTitle}>Account No.</td>
                                                                    <td style={bankValue}>-</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={bankTitle}>IFSC</td>
                                                                    <td style={bankValue}>-</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={bankTitle}>Branch</td>
                                                                    <td style={bankValue}>-</td>
                                                                </tr>

                                                            </tbody>

                                                        </table>

                                                    </div>

                                                </div>

                                                <div
                                                    style={{
                                                        border: "2px solid #000",
                                                        borderTop: "none",
                                                        minHeight: "150px",
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "35%",
                                                            padding: "15px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontWeight: "bold",
                                                                fontSize: "15px",
                                                            }}
                                                        >
                                                            For {company.name}
                                                        </div>

                                                        {/* Signature Space */}
                                                        <div
                                                            style={{
                                                                height: "70px",
                                                                width: "100%",
                                                            }}
                                                        ></div>

                                                        <div
                                                            style={{
                                                                borderTop: "1px solid #000",
                                                                width: "100%",
                                                                textAlign: "center",
                                                                paddingTop: "8px",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            Authorized Signatory
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ===================== FOOTER ===================== */}

                                                <div
                                                    style={{
                                                        border: "2px solid #000",
                                                        borderTop: "none",
                                                        textAlign: "center",
                                                        padding: "10px",
                                                        fontSize: "12px",
                                                        background: "#f8f8f8",
                                                    }}
                                                >

                                                    SUBJECT TO MUMBAI JURISDICTION

                                                    <br />

                                                    Thank you for your business.

                                                </div>

                                                {/* ===================== BUTTONS ===================== */}

                                                <div
                                                    className="no-print mb-2"
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "end",
                                                        gap: "10px",
                                                        marginTop: "20px",
                                                    }}
                                                >

                                                    <button
                                                        className="btn btn-success"
                                                        onClick={handlePrint}
                                                    >
                                                        Print Invoice
                                                    </button>

                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={() => setShowDownloadModal(false)}
                                                    >
                                                        Close
                                                    </button>

                                                </div>



                                            </div>


                                            <style>
                                                {`
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `}
                                            </style>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })()}

                    {hasMore && (
                        <div className="text-center mt-3">
                            <button
                                className="btn btn-primary"
                                onClick={handleLoadMore}
                            >
                                Load More
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Enquiry



export const exportInvoiceToExcel = (selectedQuotation) => {
    const items = selectedQuotation.items
        ? JSON.parse(selectedQuotation.items)
        : [];

    /* ================= HEADER ================= */
    const headerData = [
        ["STAR SIGNATURE SERVICES"],
        [
            "A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA"
        ],
        ["Phone: 9209206677 / 9209203355 / 9324004632"],
        ["Email: starsignatureservices@gmail.com"],
        ["GSTIN: 27ADYPY53133M2ZH"],
        [],
        ["Customer Detail"],
        [`Name: ${selectedQuotation.party_name}`],
        [`Contact: ${selectedQuotation.party_phone}`],
        [`Address: ${selectedQuotation.party_address}`],
        [`Date: ${selectedQuotation.date}`],
        [
            `Bill By: ${selectedQuotation.added_first_name || ""} ${selectedQuotation.added_middle_name || ""} ${selectedQuotation.added_last_name || ""}`
        ],
        []
    ];

    /* ================= ITEMS ================= */
    const itemHeader = [["Item Name", "Qty"]];

    const itemRows = items.length
        ? items.map((item) => [item.name, item.qty])
        : [["No Items Found", ""]];

    const remarkSection = selectedQuotation.remark
        ? [
            [],
            ["Remark"],
            [selectedQuotation.remark]
        ]
        : [];

    /* ================= FINAL SHEET DATA ================= */
    const finalData = [
        ...headerData,
        ...itemHeader,
        ...itemRows,
        ...remarkSection
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(finalData);

    /* ================= COLUMN WIDTH ================= */
    worksheet["!cols"] = [
        { wch: 40 }, // Item Name / Text
        { wch: 15 }  // Qty
    ];

    /* ================= WORKBOOK ================= */
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Detail");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const blob = new Blob([excelBuffer], {
        type: "application/octet-stream"
    });

    saveAs(
        blob,
        `Customer_Detail_${selectedQuotation.party_name || "Invoice"}.xlsx`
    );
};

